module.exports = __webpack_public_path__ + "img/corner-top.10b65aff.svg";